import { ContractResponseDtoContractStatusEnum } from 'libs/pinnacle-sdk';
import { SubmissionResponseDtoStatusEnum } from 'libs/pinnacle-sdk/models/SubmissionResponseDto';

export const isSubmissionEditable = (
  status: SubmissionResponseDtoStatusEnum
) => {
  const nonEditableStatuses: SubmissionResponseDtoStatusEnum[] = [
    SubmissionResponseDtoStatusEnum.Quoted,
    SubmissionResponseDtoStatusEnum.Declined,
    SubmissionResponseDtoStatusEnum.Cancelled,
    SubmissionResponseDtoStatusEnum.Complete,
  ];
  return !nonEditableStatuses.includes(status);
};

export const isContractEditable = (
  status: ContractResponseDtoContractStatusEnum
) => {
  const nonEditableStatuses: ContractResponseDtoContractStatusEnum[] = [
    ContractResponseDtoContractStatusEnum.Bound,
    ContractResponseDtoContractStatusEnum.Cancelled,
    ContractResponseDtoContractStatusEnum.NotTakenUp,
  ];
  return !nonEditableStatuses.includes(status);
};

export const isSubmissionSettled = (
  status: SubmissionResponseDtoStatusEnum
) => {
  const settledStatuses: SubmissionResponseDtoStatusEnum[] = [
    SubmissionResponseDtoStatusEnum.Complete,
    SubmissionResponseDtoStatusEnum.Declined,
    SubmissionResponseDtoStatusEnum.Cancelled,
  ];
  return settledStatuses.includes(status);
};
